import { useState } from 'react';
import { usePopper } from 'react-popper';
import { Link } from 'react-router-dom';
import styles from './TableRow.module.sass';

const TableRow = ({
    children, className,

    href,
    dropdown,
    ...props
}: Props & any) => {
    const [ref, setRef] = useState<any>(null);
    const [popperRef, setPopperRef] = useState<any>(null);
    const { styles: popperStyle, attributes } = usePopper<any>(
        ref,
        popperRef,
        {
            placement: 'bottom'
        }
    );

    if (href) {
        return <Link
            to={href}
            className={styles['tablerow']}
            {...props}
        >
            { children }
        </Link>
    }

    return <div
        className={`${styles['tablerow']} ${className || ''}`}
        {...props}
    >
        { children }

        {
            dropdown && <div className={styles['tablerow__toolbox']}>
                { dropdown }
            </div>
        }
    </div>;
}

interface Props {
    children?: any
    style?: any
    href?: string
    dropdown?: any
}

export default TableRow;